module.exports = __webpack_public_path__ + "img/Kjærlighet_Bilde-av-Ørstavik-under-Å-finne-sitt-eget-språk.de92ee36.jpg";